import React from "react";
import VTMarketing2 from "../page/VTMarketing2";

export default function LandingMarketing2({page}) {
    return (
        <>
            <VTMarketing2/>
        </>
    );
}
